mutation blastCreate($teamId: ID!, $recipients: [BlastRecipient]) {
  blastCreate(teamId: $teamId, recipients: $recipients) {
    id
  }
}
